import { ModuleSortColumns } from '@/jbi-shared/types/jtms.types';
import {
  ModuleFilterOptions,
  ModuleSortableHeaderOption
} from './module.types';

// Create deafult filter state for trainer search components
export const initialFilterState = (): ModuleFilterOptions => ({
  name: '',
  type: '',
  status: ''
});

// Sortable header option values specific to trainer accreditations table ONLY
export const moduleSortableHeaders: ModuleSortableHeaderOption[] = [
  {
    columnName: 'Course Module Name',
    sortColumn: ModuleSortColumns.NAME,
    sort: true
  },
  {
    columnName: 'Course Type',
    sortColumn: ModuleSortColumns.TYPE,
    sort: true
  },
  {
    columnName: 'Status',
    sortColumn: '',
    sort: false
  }
];
